"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _echarts = _interopRequireDefault(require("echarts/lib/echarts"));
var _echartsForReact = _interopRequireDefault(require("echarts-for-react"));
var _reactTooltip = _interopRequireDefault(require("react-tooltip"));
var _reactStringReplace = _interopRequireDefault(require("react-string-replace"));
var _classnames = _interopRequireDefault(require("classnames"));
var _underscore = require("underscore");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
require("./AnalysisCard.css");
var _StandardPerformanceTable = _interopRequireDefault(require("../StandardPerformance/StandardPerformanceTable.js"));
var _DetailsTable = _interopRequireDefault(require("../StandardPerformance/DetailsTable.js"));
var _HoldingsTable = _interopRequireDefault(require("../StandardPerformance/HoldingsTable.js"));
var _functions = require("../../util/functions");
var _types = require("@babel/types");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _i18n = _interopRequireDefault(require("../../util/i18n.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const CHART_HEIGHT = '350px';
const COLORS = {
  blue: '#0047BB',
  teal: '#050139',
  grey: '#050139',
  orange: '#F68D2E',
  auburn: '#84344E',
  sky: '#00A9E0',
  green: '#658D1B',
  white: '#FFFFFF',
  silver: '#BDC2C6'
};

// Map for plural field names that need conversion to singular
const FUND_KEY_MAP = {
  expenseRatiosGross: 'expenseRatioGross',
  assetClasses: 'assetClass',
  categories: 'category',
  wtCategories: 'wtCategory',
  geoFocuses: 'geoFocus',
  ttmDivYieldsOrdinaryIncome: 'ttmDivYieldOrdinaryIncome',
  entities: 'entity',
  expenseRatiosAdjusted: 'expenseRatioAdjusted'
};
const PERFORMANCE_TABLE_TYPES = ['portfolio-performance', 'portfolio-holdings', 'fund-performance', 'fund-details'];
class AnalysisCard extends _react.default.PureComponent {
  constructor(props) {
    super(props);
    this.handlePerformanceView = this.handlePerformanceView.bind(this);
    this.state = {
      cardHovered: false,
      showAllDetails: !this.props.showDetailsOnHover,
      showPerformanceView: 'portfolio-performance',
      translationDictionary: this.props.translationDictionary ? this.props.translationDictionary : _i18n.default
    };
    this.handleScrollToTop = this.handleScrollToTop.bind(this);
  }
  handlePerformanceView(type) {
    this.setState({
      showPerformanceView: type
    });
  }
  handleScrollToTop() {
    let nav = document.getElementById(this.props.topOfAppId);
    if (nav) {
      nav.scrollIntoView({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    }
  }

  // Render a Line chart with all options
  renderLineChart() {
    const {
      categoryData,
      seriesData,
      categoryIsDate,
      showChartLabels,
      showAxes,
      seriesCurrencyLabel,
      seriesColor,
      isoCode,
      entityCCY
    } = this.props;
    const {
      showAllDetails
    } = this.state;
    let option = {
      xAxis: {
        type: 'category',
        data: categoryIsDate ? categoryData.map(category => {
          return (0, _functions.formatShortDate)(category);
        }) : categoryData,
        axisTick: {
          show: true,
          //showAllDetails && showChartLabels,
          lineStyle: {
            color: COLORS.silver
          }
        },
        axisLine: {
          lineStyle: {
            color: COLORS.grey
          }
        },
        axisLabel: {
          show: true,
          //showAllDetails && showChartLabels,
          fontFamily: 'Avenir, "Avenir LT 55 Roman", sans-serif',
          fontSize: 10,
          color: COLORS.grey,
          rotate: 45
        },
        show: true //showAllDetails && showAxes,
      },
      yAxis: {
        type: 'value',
        axisTick: {
          show: true,
          //showAllDetails && showChartLabels,
          lineStyle: {
            color: COLORS.silver
          }
        },
        axisLine: {
          lineStyle: {
            color: COLORS.grey
          }
        },
        axisLabel: {
          show: true,
          //showAllDetails && showChartLabels,
          fontFamily: 'Avenir, "Avenir LT 55 Roman", sans-serif',
          fontSize: 10,
          color: COLORS.grey,
          formatter: seriesCurrencyLabel ? seriesCurrencyLabel + '{value}' : '{value}'
        },
        splitLine: {
          show: false
        },
        show: true //showAllDetails && showAxes,
      },
      series: seriesData.map((series, index) => {
        return {
          data: series.data,
          type: 'line',
          symbol: 'none',
          name: series.name,
          lineStyle: {
            color: series.color
          },
          // Show area shading for first series only
          areaStyle: index === 0 ? {
            // color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
            //   offset: 0,
            //   color: seriesColor,
            // }, {
            //   offset: 1,
            //   color: COLORS.white,
            // }])
            color: series.color
          } : null
        };
      }),
      grid: {
        show: false,
        containLabel: true,
        top: 15,
        left: 30,
        right: 30,
        bottom: 30
      },
      legend: {
        data: ['高度(km)与气温(°C)变化关系']
      },
      tooltip: {
        trigger: 'axis',
        formatter: function (params) {
          let res = params[0].axisValue + '';
          for (let i = 0, l = params.length; i < l; i++) {
            if (!params[i].value) {
              continue;
            }
            res += '<br/>' + '<span style="color:' + seriesData[i].color + ';font-weight:700;">' + params[i].seriesName + '</span>: ' + (seriesCurrencyLabel ? new Intl.NumberFormat(isoCode, {
              style: 'currency',
              currency: entityCCY,
              maximumFractionDigits: 0,
              minimumFractionDigits: 0
            }).format(params[i].value) : (0, _functions.formatNumber)(params[i].value, 0));
          }
          return res;
        },
        backgroundColor: '#FFF',
        borderWidth: 1,
        borderColor: COLORS.grey,
        borderRadius: 0,
        textStyle: {
          color: '#050139',
          align: 'left',
          fontSize: 10
        }
      }
    };
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "chart",
      style: {
        minHeight: this.props.minChartHeight
      },
      onClick: this.props.onChartClick
    }, /*#__PURE__*/_react.default.createElement(_echartsForReact.default, {
      option: option,
      notMerge: true,
      lazyUpdate: true,
      style: {
        height: CHART_HEIGHT
      }
    }));
  }

  // Render a Bar chart with all options (horizontal)
  renderBarChart() {
    const {
      seriesData,
      categoryIsDate,
      showChartLabels,
      showAxes,
      seriesCurrencyLabel,
      seriesIsPercentage,
      sliceCategoriesToN
    } = this.props;

    // Create new array of sliced data series (choped to 10 categories if necessary and then sum the rest to an 'other' category if required
    let slicedSeries = [];
    seriesData.forEach((series, index) => {
      const slicedData = this.sliceDataSeries(series.data, series.categories, sliceCategoriesToN);
      slicedSeries.push({
        name: series.name,
        color: series.color,
        data: slicedData[0],
        categories: slicedData[1]
      });
    });

    // Get distinct categories across all the series (now they've been sliced)
    // This should be in the order of the first series (desc) given we take that
    // one first.
    let distinctCategories = [];
    slicedSeries.forEach((series, index) => {
      distinctCategories = (0, _underscore.union)(distinctCategories, series.categories);
    });

    // Resort the distinct categories by the first (i.e., most important) series' categories (that
    // were already sorted)
    distinctCategories.sort(function (a, b) {
      return slicedSeries[0].categories.indexOf(a) - slicedSeries[0].categories.indexOf(b);
    });

    // Get the final series by realigning to the distinct set of categories
    let finalSeries = [];
    seriesData.forEach((series, index) => {
      finalSeries.push({
        name: series.name,
        color: series.color,
        categories: distinctCategories,
        data: distinctCategories.map(category => {
          let weight = series.data[series.categories.indexOf(category)];
          return weight ? weight : 0;
        })
      });
    });
    const {
      showAllDetails
    } = this.state;
    let option = {
      legend: {
        show: finalSeries.length > 1,
        data: finalSeries.map(series => {
          return {
            name: series.name,
            icon: 'rect',
            textStyle: {
              align: 'right',
              fontSize: 8,
              color: COLORS.grey,
              fontWeight: 500
            }
          };
        }),
        orient: 'vertical',
        top: 0,
        right: 10,
        itemWidth: 10,
        itemHeight: 5,
        itemGap: 2
      },
      xAxis: {
        type: 'value',
        axisLabel: {
          show: false,
          //showAllDetails && showChartLabels,
          fontFamily: 'Avenir, "Avenir LT 55 Roman", sans-serif',
          fontSize: 10,
          color: COLORS.grey,
          rotate: 45,
          formatter: seriesIsPercentage ? function (value, index) {
            return (0, _functions.formatPercent)(value, 0, true);
          } : '{value}'
        },
        axisTick: {
          show: false,
          //showAllDetails && showChartLabels,
          lineStyle: {
            color: COLORS.silver
          }
        },
        axisLine: {
          lineStyle: {
            color: COLORS.grey
          }
        },
        splitLine: {
          show: false
        },
        show: false //showAllDetails && showAxes,
      },
      yAxis: {
        type: 'category',
        data: categoryIsDate ? finalSeries[0].categories.map(category => {
          return (0, _functions.formatShortDate)(category);
        }) : finalSeries[0].categories,
        axisLabel: {
          show: true,
          //showAllDetails && showChartLabels,
          fontFamily: 'Avenir, "Avenir LT 55 Roman", sans-serif',
          fontSize: 11,
          color: COLORS.grey,
          formatter: seriesCurrencyLabel ? seriesCurrencyLabel + '{value}' : '{value}'
        },
        axisTick: {
          show: false,
          //showAllDetails && showChartLabels,
          lineStyle: {
            color: COLORS.silver
          }
        },
        axisLine: {
          lineStyle: {
            color: COLORS.grey
          }
        },
        show: true //showAllDetails && showAxes,
      },
      series: finalSeries.map(series => {
        return {
          name: series.name,
          data: series.data,
          type: 'bar',
          itemStyle: {
            color: series.color
          },
          areaStyle: {
            // color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
            //   offset: 0,
            //   color: series.color,
            // }, {
            //   offset: 1,
            //   color: COLORS.white,
            // }])
            color: series.color
          },
          cursor: 'default',
          label: {
            show: true,
            position: 'right',
            fontFamily: 'Avenir, "Avenir LT 55 Roman", sans-serif',
            fontSize: 11,
            color: COLORS.grey,
            formatter: seriesIsPercentage ? function (params) {
              return (0, _functions.formatPercent)(params.value, 0, true);
            } : '{value}'
          }
        };
      }),
      grid: {
        show: false,
        containLabel: true,
        top: finalSeries.length > 1 ? 25 : 15,
        left: 30,
        right: 35,
        bottom: 30
      }
    };
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "chart",
      style: {
        minHeight: this.props.minChartHeight
      },
      onClick: this.props.onChartClick
    }, /*#__PURE__*/_react.default.createElement(_echartsForReact.default, {
      option: option,
      notMerge: true,
      lazyUpdate: true,
      style: {
        height: CHART_HEIGHT
      }
    }));
  }

  // Render a Column chart with all options
  renderColumnChart() {
    const {
      categoryData,
      seriesData,
      categoryIsDate,
      showChartLabels,
      showAxes,
      seriesCurrencyLabel,
      seriesColor
    } = this.props;
    const {
      showAllDetails
    } = this.state;
    let option = {
      xAxis: {
        type: 'category',
        data: categoryIsDate ? categoryData.map(category => {
          return (0, _functions.formatShortDate)(category);
        }) : categoryData,
        axisLabel: {
          show: true,
          // showAllDetails && showChartLabels,
          fontFamily: 'Avenir, "Avenir LT 55 Roman", sans-serif',
          fontSize: 10,
          color: COLORS.grey,
          rotate: 45
        },
        axisTick: {
          show: false,
          //showAllDetails && showChartLabels,
          lineStyle: {
            color: COLORS.silver
          }
        },
        axisLine: {
          lineStyle: {
            color: COLORS.grey
          }
        },
        show: true //showAllDetails && showAxes,
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          show: true,
          //showAllDetails && showChartLabels,
          fontFamily: 'Avenir, "Avenir LT 55 Roman", sans-serif',
          fontSize: 10,
          color: COLORS.grey,
          formatter: seriesCurrencyLabel ? seriesCurrencyLabel + '{value}' : '{value}'
        },
        axisTick: {
          show: true,
          //showAllDetails && showChartLabels,
          lineStyle: {
            color: COLORS.silver
          }
        },
        axisLine: {
          lineStyle: {
            color: COLORS.grey
          }
        },
        splitLine: {
          show: false
        },
        show: true //showAllDetails && showAxes,
      },
      series: [{
        data: seriesData,
        type: 'bar',
        itemStyle: {
          color: seriesColor
        },
        areaStyle: {
          // color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
          //   offset: 0,
          //   color: seriesColor,
          // }, {
          //   offset: 1,
          //   color: COLORS.white,
          // }])
          color: seriesColor
        },
        cursor: 'default'
      }],
      grid: {
        show: false,
        containLabel: true,
        top: 15,
        left: 30,
        right: 30,
        bottom: 30
      }
    };
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "chart",
      style: {
        minHeight: this.props.minChartHeight
      },
      onClick: this.props.onChartClick
    }, /*#__PURE__*/_react.default.createElement(_echartsForReact.default, {
      option: option,
      notMerge: true,
      lazyUpdate: true,
      style: {
        height: CHART_HEIGHT
      }
    }));
  }

  // Render a TreeMap with all options
  renderTreemap() {
    const {
      seriesData
    } = this.props;
    let option = {
      tooltip: {
        backgroundColor: '#FFF',
        borderWidth: 1,
        borderColor: '#5A6770',
        borderRadius: 3,
        padding: 10,
        formatter: '<b>{b}</b> {c}%<br />Click to open in Fund Comparison',
        textStyle: {
          color: '#5A6770',
          align: 'center',
          fontSize: 12
        }
      },
      series: [{
        data: seriesData,
        type: 'treemap',
        colorMappingBy: 'id',
        //dimensions: ['value', 'formattedValue'],
        roam: false,
        nodeClick: 'link',
        breadcrumb: {
          show: false
        },
        silent: false,
        left: 50,
        top: 10,
        bottom: 0,
        width: '80%',
        height: '80%',
        itemStyle: {
          gapWidth: 2
        },
        color: [COLORS.blue, COLORS.teal, COLORS.grey, COLORS.orange, COLORS.sky, COLORS.green]
      }]
    };
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "chart",
      style: {
        minHeight: this.props.minChartHeight
      },
      onClick: this.props.onChartClick
    }, /*#__PURE__*/_react.default.createElement(_echartsForReact.default, {
      option: option,
      notMerge: true,
      lazyUpdate: true,
      style: {
        height: CHART_HEIGHT,
        maxWidth: '500px'
      }
    }));
  }

  // Render a table with Key Metrics
  renderKeyMetrics() {
    const {
      seriesData
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)('chart', this.props.onChartClick ? 'clickable' : ''),
      style: {
        minHeight: this.props.minChartHeight
      },
      onClick: this.props.onChartClick
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "keymetrics"
    }, seriesData ? seriesData.map((metric, index) => {
      return /*#__PURE__*/_react.default.createElement("div", {
        key: metric.name,
        className: (0, _classnames.default)('metric-row', index === seriesData.length - 1 ? 'last' : '', metric.clickable ? 'scroll-to' : ''),
        onClick: event => {
          var chart = document.getElementById(metric.name + '-chart');
          if (chart) {
            chart.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            });
          }
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "metric-title"
      }, metric.title), metric.value2 && /*#__PURE__*/_react.default.createElement("div", {
        className: 'value2 ' + (metric.boldValue === metric.value2 ? 'value-bold' : '')
      }, metric.value2, /*#__PURE__*/_react.default.createElement("span", {
        className: "symbol"
      }, metric.symbol)), /*#__PURE__*/_react.default.createElement("div", {
        className: 'value ' + (metric.boldValue === metric.value ? 'value-bold' : '')
      }, metric.value, /*#__PURE__*/_react.default.createElement("span", {
        className: "symbol"
      }, metric.symbol)), /*#__PURE__*/_react.default.createElement("div", {
        className: "metric-desc"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "desc"
      }, metric.description), /*#__PURE__*/_react.default.createElement("div", {
        className: "metric-tooltip"
      }, /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
        "data-tip": true,
        "data-for": metric.name + '-desc',
        icon: "question-circle",
        size: "sm"
      })), /*#__PURE__*/_react.default.createElement(_reactTooltip.default, {
        id: metric.name + '-desc',
        type: "light",
        className: "tooltip",
        effect: "float"
      }, metric.tooltip)));
    }) : null));
  }

  // Render info card
  renderInfoText() {
    const {
      infoText
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)('chart', this.props.onChartClick ? 'clickable' : ''),
      style: {
        minHeight: this.props.minChartHeight
      },
      onClick: this.props.onChartClick
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "info-text",
      dangerouslySetInnerHTML: {
        __html: infoText
      }
    }));
  }

  // Pivot a holdings based data set into an array of funds
  pivotData(data) {
    let newData = [];

    // Assumes data is a holdings object. User tickers as array to loop over
    data.tickers.forEach(function (ticker, index) {
      let newFund = {};
      Object.keys(data).forEach(function (key) {
        // Get the new key name - replace it directly if there is a map, or remove the last 's'

        if (Array.isArray(data[key])) {
          // console.log(key + ',');
          // console.log('Writing ' + ticker + ' for key ' + key + ' with data ' + data[key][index]);
          const newKeyName = FUND_KEY_MAP[key] ? FUND_KEY_MAP[key] : key.replace(/s$/, '');
          newFund[newKeyName] = data[key][index];
        } else {
          newFund[key] = data[key];
        }
      });
      newData.push(newFund);
    });
    return newData;
  }
  renderPerformanceTable() {
    const {
      personalStrategy,
      showPerfCommonPeriod,
      showPerfTableHoldings,
      portfolioPerformanceFootnoteText,
      fundDetailsFootnoteText,
      fundPerformanceFootnoteText,
      portfolioHoldingsFootnoteText,
      weightDecimals
    } = this.props;
    const {
      showPerformanceView,
      translationDictionary
    } = this.state;

    // If the holdings is an array then it should already be a funds array list. If not
    // its holdings so pivot the data
    const fundData = personalStrategy.holdings.length > 1 ? personalStrategy.holdings : this.pivotData(personalStrategy.holdings[0]);
    let portfolioPerformance = [{
      stdPerformance: personalStrategy.stdPerformance,
      name: personalStrategy.name,
      type: personalStrategy.type,
      holdings: personalStrategy.holdings
    }];

    // If a benchmark exists then add to the portfolio performance
    if (personalStrategy.benchmarks && personalStrategy.benchmarks.length > 0) {
      // Add on all the benchmarks to the array using map
      portfolioPerformance = portfolioPerformance.concat(personalStrategy.benchmarks.map(benchmark => {
        return {
          stdPerformance: benchmark.stdPerformance,
          name: benchmark.name,
          type: benchmark.type,
          holdings: benchmark.holdings
        };
      }));
    }
    let tableToShow;
    switch (showPerformanceView) {
      case 'portfolio-performance':
        tableToShow = /*#__PURE__*/_react.default.createElement(_StandardPerformanceTable.default, {
          data: portfolioPerformance,
          translationDictionary: translationDictionary,
          showTitle: false,
          showCommonPeriod: showPerfCommonPeriod,
          commonPeriodStart: personalStrategy.commonPeriodStart,
          commonPeriodEnd: personalStrategy.commonPeriodEnd,
          showSinceInception: false,
          isPortfolio: true,
          sidePadding: 60,
          footnote: portfolioPerformanceFootnoteText ? portfolioPerformanceFootnoteText : null
        });
        break;
      case 'fund-performance':
        tableToShow = /*#__PURE__*/_react.default.createElement(_StandardPerformanceTable.default, {
          data: fundData,
          translationDictionary: translationDictionary,
          showTitle: false,
          showCommonPeriod: false,
          showSinceInception: true,
          sidePadding: 60,
          footnote: fundPerformanceFootnoteText ? fundPerformanceFootnoteText : null
        });
        break;
      case 'fund-details':
        tableToShow = /*#__PURE__*/_react.default.createElement(_DetailsTable.default, {
          data: fundData,
          translationDictionary: translationDictionary,
          showTitle: false,
          sidePadding: 60,
          footnote: fundDetailsFootnoteText ? fundDetailsFootnoteText : null
        });
        break;
      case 'portfolio-holdings':
        tableToShow = /*#__PURE__*/_react.default.createElement(_HoldingsTable.default, {
          data: portfolioPerformance,
          translationDictionary: translationDictionary,
          showTitle: false,
          isPortfolio: true,
          sidePadding: 60,
          footnote: portfolioHoldingsFootnoteText ? portfolioHoldingsFootnoteText : null,
          weightDecimals: weightDecimals
        });
        break;
      default:
        tableToShow = null;
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)('chart', this.props.onChartClick ? 'clickable' : ''),
      style: {
        minHeight: this.props.minChartHeight
      },
      onClick: this.props.onChartClick
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "align-right"
    }, PERFORMANCE_TABLE_TYPES.map(type => {
      // Filter out holdings if not required
      if (!showPerfTableHoldings && type === 'portfolio-holdings') {
        return null;
      }
      return /*#__PURE__*/_react.default.createElement("button", {
        key: type,
        onClick: this.handlePerformanceView.bind(this, type),
        className: (0, _classnames.default)(showPerformanceView === type ? 'active' : 'not-active')
      }, translationDictionary.t(type));
    })), tableToShow);
  }

  // Handle a hover over the card
  setCardHovered() {
    const currentHoverState = this.state.cardHovered;
    this.setState({
      cardHovered: !currentHoverState,
      // If the card is set up to only reveal details on hover then check if 
      // details should be shown
      showAllDetails: !this.props.showDetailsOnHover || this.props.showDetailsOnHover && !currentHoverState
    });
  }

  /**
   * Order a set of category data from big to small then keep the 
  /* top n of those. Finally sum the rest and label as 'Other'
   * @param {*} seriesData 
   * @param {*} categoryData 
   * @param {*} numberOfItemsToKeep 
   */
  sliceDataSeries(seriesData, categoryData, numberOfItemsToKeep) {
    // Zip up the data together
    let zippedData = (0, _underscore.zip)(seriesData, categoryData);

    // Sort the data by the series (values)
    let orderedData = zippedData.sort((a, b) => b[0] - a[0]);
    if (numberOfItemsToKeep) {
      // Take the top n
      let topData = orderedData.slice(0, numberOfItemsToKeep);

      // Take the remaining 
      let otherData = orderedData.slice(numberOfItemsToKeep);

      // Check if there is anything else to combine
      if (otherData.length > 0) {
        // Sum up the series data element of the remaining elements
        let totalOther = otherData.map(elem => {
          return elem[0];
        }).reduce(function sumofArray(sum, num) {
          return sum + num;
        });

        // Add the other to the remaining
        topData.push([totalOther, 'Other']);
      }

      // Unzip it all
      orderedData = topData;
    }

    // Unzip it all
    let newData = (0, _underscore.unzip)(orderedData);

    // Return it as an array - first element the series values, second the categories
    return [newData[0].reverse(), newData[1].reverse()];
  }
  render() {
    const {
      chartType,
      heroNumber,
      heroTitle,
      heroNumberIsPercent,
      chartTitle,
      footnoteText,
      showDetailsOnHover,
      cardTitle,
      idOfCard,
      metricComparisonNames,
      topOfAppId
    } = this.props;
    const {
      showAllDetails,
      cardHovered
    } = this.state;
    let chart;
    switch (chartType) {
      case 'line':
        chart = this.renderLineChart();
        break;
      case 'bar':
        chart = this.renderBarChart();
        break;
      case 'treemap':
        chart = this.renderTreemap();
        break;
      case 'column':
        chart = this.renderColumnChart();
        break;
      case 'keymetrics':
        chart = this.renderKeyMetrics();
        break;
      case 'performancetable':
        chart = this.renderPerformanceTable();
        break;
      case 'infotext':
        chart = this.renderInfoText();
        break;
      default:
        chart = /*#__PURE__*/_react.default.createElement("div", null, "No Chart");
    }

    // Replace newlines and strong tags in the html
    let formattedFootnoteText;
    if (footnoteText) {
      formattedFootnoteText = (0, _reactStringReplace.default)(footnoteText, '<br/>', match => /*#__PURE__*/_react.default.createElement("br", {
        key: Math.random()
      }));
      formattedFootnoteText = (0, _reactStringReplace.default)(formattedFootnoteText, /<strong>(.*)<\/strong>/g, match => /*#__PURE__*/_react.default.createElement("strong", {
        key: Math.random()
      }, match));
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)('analysis-card', {
        'no-shrink-height': cardHovered && showDetailsOnHover && heroNumber
      }),
      onMouseEnter: () => this.setCardHovered(),
      onMouseLeave: () => this.setCardHovered(),
      id: idOfCard
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "card-title"
    }, cardTitle ? cardTitle : null), topOfAppId && /*#__PURE__*/_react.default.createElement("div", {
      className: "up-arrow",
      onClick: this.handleScrollToTop
    }, /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: "chevron-up",
      size: "sm"
    })), heroTitle ? /*#__PURE__*/_react.default.createElement("div", {
      className: "hero-title",
      dangerouslySetInnerHTML: {
        __html: heroTitle
      }
    }) : null, heroNumber ? /*#__PURE__*/_react.default.createElement("div", {
      className: "hero-number"
    }, /*#__PURE__*/_react.default.createElement("span", null, heroNumberIsPercent ? (0, _functions.formatPercent)(heroNumber, 1) : heroNumber)) : null, /*#__PURE__*/_react.default.createElement("div", {
      className: "chart-title"
    }, chartTitle ? chartTitle : null), metricComparisonNames && /*#__PURE__*/_react.default.createElement("div", {
      className: "metrics-header"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "metrics-header-name"
    }, metricComparisonNames[0]), /*#__PURE__*/_react.default.createElement("div", {
      className: "metrics-header-name2"
    }, metricComparisonNames[1])), chart, formattedFootnoteText && showAllDetails ? /*#__PURE__*/_react.default.createElement("div", {
      className: "chart-footnote"
    }, formattedFootnoteText) : null);
  }
}
exports.default = AnalysisCard;
_defineProperty(AnalysisCard, "defaultProps", {
  chartType: 'bar',
  showChartLabels: true,
  showLegend: true,
  showGrid: true,
  showAxes: true,
  categoryIsDate: true,
  heroNumberIsPercent: true,
  shrinkHeight: true,
  showDetailsOnHover: false,
  seriesColor: COLORS.blue,
  seriesIsPercentage: false,
  isoCode: 'en-US',
  entityCCY: 'USD',
  topOfAppId: 'top-of-app',
  showPerfCommonPeriod: true,
  showPerfTableHoldings: false,
  weightDecimals: 2
});
AnalysisCard.propTypes = {
  /**
   * Type of chart to be rendered
   */
  chartType: _propTypes.default.string,
  /**
   * Required - ID of chart so it can be easily scrolled to
   */
  idOfCard: _propTypes.default.string.isRequired,
  /**
   * Required - ID of top of app used for scrolling back to top
   */
  topOfAppId: _propTypes.default.string.isRequired,
  /**
   * Top title of the card
   */
  cardTitle: _propTypes.default.string,
  /**
   * Array of categories to be used in the chart
   */
  categoryData: _propTypes.default.array,
  /**
   * Check if the category contains a date
   */
  categoryIsDate: _propTypes.default.bool,
  /**
   * Array of series dictionaries each containing the 
   * echart series name and data. 
   */
  seriesData: _propTypes.default.array,
  /**
   * PersonalStrategy object - only used for Performance table as fields are needed
   * from all over the place
   */
  personalStrategy: _propTypes.default.object,
  /**
   * Footnote text to be placed under the chart
   */
  footnoteText: _propTypes.default.string,
  /**
   * Hero number for display above the chart (optional)
   */
  heroNumber: _propTypes.default.number,
  /**
   * Hero title for display above the Hero number
   */
  heroTitle: _propTypes.default.string,
  /**
   * Hero tooltip for hover (e.g., common period dates)
   */
  heroTooltip: _propTypes.default.string,
  /**
   * Format the hero number as a percentage
   */
  heroNumberIsPercent: _propTypes.default.bool,
  /**
   * Show chart labels (default is true). Will remove all ticks and labels if false
   */
  showChartLabels: _propTypes.default.bool,
  /**
   * Show legend (default is true)
   */
  showLegend: _propTypes.default.bool,
  /**
   * Show Grid (default is true)
   */
  showGrid: _propTypes.default.bool,
  /**
   * Show Axes (default is true)
   */
  showAxes: _propTypes.default.bool,
  /**
   * Currency label for series
   */
  seriesCurrencyLabel: _propTypes.default.string,
  /**
   * Callback function if user clicks on the chart
   */
  onChartClick: _propTypes.default.func,
  /**
   * Remove spacing if the titles and footnotes aren't being shown. Used when
   * hovering on an adjacent chart. IF false then will never shrink
   */
  shrinkHeight: _propTypes.default.bool,
  /**
   * Force the card to show titles of chart, footnote, and other things on hover
   */
  showDetailsOnHover: _propTypes.default.bool,
  /**
   * Optional parameter for color of the series in a chart
   */
  seriesColor: _propTypes.default.string,
  /**
   * Optional parameter to format the series as a percentage if needed
   */
  seriesIsPercentage: _propTypes.default.bool,
  /**
   * Optional prop to slice the category array to a given number with the rest as 'Other'
   */
  sliceCategoriesToN: _propTypes.default.number,
  /**
   * Translation dictionary (i18) - needed for tables
   */
  translationDictionary: _propTypes.default.object,
  /**
   * Optional parameter isoCode of chart
   */
  isoCode: _propTypes.default.string,
  /**
   * Optional parameter Currency of chart - used for formatting
   */
  entityCCY: _propTypes.default.string,
  /**
   * Optional parameter to show or hide the Common period column in the Portfolio Standard Performance Table. Default True
   */
  showPerfCommonPeriod: _propTypes.default.bool,
  /**
   * Optional parameter show the holdings inside the performance table. Would work for portfolios. Default false.
   */
  showPerfTableHoldings: _propTypes.default.bool,
  /**
   * Footnote text to be placed under the Holdings table
   */
  portfolioHoldingsFootnoteText: _propTypes.default.string,
  /**
   * Footnote text to be placed under the Portfolio Performance table
   */
  portfolioPerformanceFootnoteText: _propTypes.default.string,
  /**
   * Footnote text to be placed under the Fund performance table
   */
  fundPerformanceFootnoteText: _propTypes.default.string,
  /**
   * Footnote text to be placed under the Fund details table
   */
  fundDetailsFootnoteText: _propTypes.default.string,
  /**
   * Specify how many decimal points to use for holdings weights. Defaults to 2.
   */
  weightDecimals: _propTypes.default.number
};